import config from 'config';

const getMaxQuantity = (value: number, maxQuantity: number = config.defaultMaxQuantity): string =>
  value <= maxQuantity ? `${value}` : `+${maxQuantity}`;

export default getMaxQuantity;
